import { createAction } from '@reduxjs/toolkit';
import User from 'types/entities/User';
import { initialValue } from '../../helperContext';
import { BaselineAffectationType, PossiblesBaselineAffectationActions } from '../../BaselineAffectationReducers';

export const setAffectationDMAction = createAction(
  BaselineAffectationType.SetAffectationDM,
  (deliveryManagers: User[]) => ({
    payload: { deliveryManagers },
  })
);

export default (state = initialValue, action: PossiblesBaselineAffectationActions) => {
  switch (action.type) {
    case BaselineAffectationType.SetAffectationDM:
      return {
        ...state,
        deliveryManagers: action?.payload?.deliveryManagers,
      };
    default:
      return state;
  }
};
